import { useEffect, useState } from "react";

import styles from "./inputs.module.css";

type CheckboxProps = {
  setValue: (value: boolean) => void;
  defaultTrue?: boolean;
  currentValue?: boolean;
};

export default function SquareCheckbox(props: CheckboxProps) {
  const [value, setValue] = useState<boolean>(
    props.defaultTrue === true ? true : false
  );

  useEffect(() => {
    setTimeout(() => {
      if (props.currentValue) {
        if (props.currentValue === true) {
          setValue(true);
        } else {
          setValue(false);
        }
      }
    }, 1000);
  }, [props.currentValue]);

  return (
    <div className={styles.checkBoxDiv}>
      <label className={styles.checkboxButton}>
        <input
          type="checkbox"
          onClick={(e) => {
            setValue(!value);
            // @ts-ignore
            props.setValue(e.target.checked);
          }}
          className={styles.checkbox}
          checked={props.currentValue ?? value}
        />
        <span className={styles.checkboxButtonControl}></span>
      </label>
    </div>
  );
}
